module.exports = __webpack_public_path__ + "img/pic-books.4ecba06.svg";